import { Avatar, Button, colors, Divider, FormControlLabel, Radio, RadioGroup, Stack, TextField, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import toast from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import GeneralLoader from '../../components/GeneralLoader';
import generateRandomColor from '../../helpers/colorGenerator';
import useQuery from '../../hooks/useQuery';
import QuestionForm from '../form';
import CommentStatus from '../../components/CommentStatus';
import CommentParent from '../../components/CommentParent';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Cookies from 'universal-cookie';
import { fetchWith401Check } from '../../helpers/http';

const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

const ModerationEdit = ({ userInfo }) => {
  const cookies = new Cookies();
  const query = useQuery();
  const id = query.get('id');
  const [answers, setAnswers] = React.useState({});
  const [metadata, setMetadata] = React.useState({}); // this is for updating needs
  const [isLoading, setIsLoading] = React.useState(false);
  const [comment, setComment] = React.useState('');
  const [comments, setComments] = React.useState([]);
  const [repository, setRepository] = React.useState({});
  const [docStatus, setDocStatus] = React.useState();
  const [section, setSection] = React.useState('');
  const [loadingState, setLoadingState] = React.useState({ deleteComment: false, createComment: false, updateReview: false });

  const fetchRepositoryByID = async () => {
    if (!id) return;
    if (!_.isEmpty(repository)) return;

    fetchWith401Check(`${API_URL}/tabledatas/summary/id?id=${id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const repoData = response?.response || {};
        setRepository({ ...repository, ...repoData });
      })
      .catch(function (err) {
        return toast.error(err.message || 'Something wrong happenned');
      });
  };

  const fetchByID = async () => {
    if (!id) return;
    setIsLoading(true);
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      body: JSON.stringify({ id }),
    };
    fetchWith401Check(`${API_URL}/tabledatas/summary`, requestOptions)
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const answersData = response?.responses[0] || [];
        const meta = response?.responses[1] || [];

        if (!_.isEmpty(answersData) && !_.isEmpty(meta)) {
          setAnswers(answersData);
          setMetadata(meta);
          setDocStatus(meta.status);
        } else {
          toast.error('No data found');
        }
      })
      .catch(function (err) {
        return toast.error(err.message);
      })
      .finally(function () {
        setIsLoading(false);
      });
  };

  const addComment = async () => {
    if (!comment) return toast.error('Please insert comment');

    fetchWith401Check(`${API_URL}/reviews/add`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
      body: JSON.stringify({
        content: { text: comment, section },
        status: 'created',
        created_by: userInfo.username,
        repository_id: repository.id,
        metadata: {},
        type: 'questionnaire',
      }),
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const data = response?.responses || {};
        toast.success('Comment saved successfully');
        fetchComments();
        setComment('');
        setSection('');
      })
      .catch(function (err) {
        return toast.error(err.message || 'Something wrong happenned');
      });
  };

  const doDeleteComment = async (item) => {
    const commentId = item.id;
    if (!commentId) return toast.error('Comment ID not found');

    setLoadingState({ ...loadingState, deleteComment: true });

    try {
      fetchWith401Check(`${API_URL}/reviews/delete_by_id`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
        body: JSON.stringify({ id: commentId }),
      })
        .then(function (response) {
          if (response.ok) {
            setLoadingState({ ...loadingState, deleteComment: false });
            toast.success('Comment has been deleted');
            fetchComments(repository.id);
            return response.json();
          }
          return Promise.reject(response);
        })
        .catch(function (err) {
          setLoadingState({ ...loadingState, deleteComment: false });
          return toast.error(err.message || 'Something wrong happenned');
        });
    } catch (error) {
      toast.error(error.message || 'Something wrong happenned');
      setLoadingState({ ...loadingState, deleteComment: false });
    }
  };

  const fetchComments = async () => {
    if (!repository.id) return;

    fetchWith401Check(`${API_URL}/reviews`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
      body: JSON.stringify({
        repository_id: repository.id,
        type: 'questionnaire',
      }),
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        console.log('check response', response?.response);
        setComments(response?.response);
      })
      .catch(function (err) {
        return toast.error(err.message || 'Something wrong happenned');
      });
  };

  React.useEffect(() => {
    fetchByID();
    fetchRepositoryByID();
  }, []);

  React.useEffect(() => {
    fetchComments();
  }, [repository.id]);
  return (
    <Stack direction='column'>
      {isLoading ? (
        <Stack direction='column'>
          <Stack sx={{ alignSelf: 'center' }}>
            <GeneralLoader isLoading={isLoading} />
          </Stack>

          <Stack direction='row' spacing={2} sx={{ width: '100vw' }} p={4}>
            <Stack direction='column' sx={{ flex: 2 }}>
              <Skeleton height={100} width='100%' count={10} />
            </Stack>
            <Stack direction='column' sx={{ flex: 1 }}>
              <Skeleton height='80vh' width='100%' count={2} />
            </Stack>
          </Stack>
        </Stack>
      ) : (
        <>
          {!_.isEmpty(answers) ? (
            <Stack direction='row' sx={{ flex: 1, maxHeight: '100vh' }}>
              <Stack sx={{ flex: 2, overflow: 'scroll' }}>
                <QuestionForm type='moderation' userInfo={userInfo} metadata={metadata} fetchedAnswers={answers || {}} />
              </Stack>

              <Stack sx={{ flex: 1 }}>
                <CommentParent
                  repository={repository}
                  comments={comments}
                  loadingState={loadingState}
                  userInfo={userInfo}
                  doDeleteComment={doDeleteComment}
                  addComment={addComment}
                  comment={comment}
                  setComment={setComment}
                  section={section}
                  setSection={setSection}
                />
              </Stack>
            </Stack>
          ) : (
            <Typography variant='body1'>No data found</Typography>
          )}
        </>
      )}
    </Stack>
  );
};

export default ModerationEdit;
